// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_YMzLd clearfix","list":"index_list_4TEFQ","pd15":"index_pd15_vSzlc clearfix","xs_word_02":"index_xs_word_02_G7Bx0","qqg":"index_qqg_wemLz"};